const EmbeddedHTML = ({ html }) => {
  return (
    <div className="p-3 p-md-5 card">
      <div dangerouslySetInnerHTML={html} />
    </div>
  );
};

export { EmbeddedHTML };
